<div class="carousel-container" id="carousel-container" #carouselcontainer>
  <carousel 
    [height] = "carouselProperties.height"
    [cellsToShow] = "carouselProperties.cellsToShow"
  >
    <div class="carousel-cell text-light text-center" *ngFor="let image of images; let i = index" [attr.data-index]="i">
        <app-image-viewer *ngIf="isFullscreen" [imgSrc]="image.name" [calledFromCarousel]="true" #elementToCheck></app-image-viewer>
        <div [ngStyle]="(image.finding=='No Finding')?{'background-color': '#00A40B'} : {'background-color': '#FF1300'}" class="label text-dark">{{image.finding}}</div>
        <ng-container *ngFor="let key of keys">
          <div *ngIf="(isFullscreen) && (key!='name') && (key!='finding')"><strong>{{key}}:</strong><span> {{image[key]}}</span></div>
        </ng-container>
        <img
          [src]="image.name"
          class="img-fluid my-carousel-images"
          [appFullscreen]= "carouselcontainer"
          (fullscreenToggle)="fullscreenToggled($event)"
          (fullscreenActive)="fullscreenActivated($event)"
          (click)="itemIndex= i"
        >
    </div>
  </carousel>
</div>